import { render } from "./TextReaderSegmento.vue?vue&type=template&id=12cbbbcc"
import script from "./TextReaderSegmento.vue?vue&type=script&lang=js"
export * from "./TextReaderSegmento.vue?vue&type=script&lang=js"

import "./TextReaderSegmento.vue?vue&type=style&index=0&id=12cbbbcc&lang=css"

import exportComponent from "C:\\SistemasProyectos\\AppWeb\\historiaClinica\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__